import { BaseQueryFn, EndpointBuilder } from '@reduxjs/toolkit/query';
import { APP_ENDPOINTS } from 'app/endpoints';
import { BaseOrder } from '../types/dtos';

export default (builder: EndpointBuilder<BaseQueryFn, string, string>) =>
    builder.mutation<void, { id: string; payload: Partial<BaseOrder> }>({
        query: ({ id, payload }) => ({
            url: `${APP_ENDPOINTS.ORDER}/${id}`,
            method: 'PATCH',
            body: payload,
        }),
        invalidatesTags: [
            { type: 'orders-with-join', id: 'GET-JOIN' },
            { type: 'order', id: 'GET-ID' },
        ],
    });
